// extracted by mini-css-extract-plugin
module.exports = {"dropdownWrapper":"pageActionDropdown_dropdownWrapper__2Qga9","title":"pageActionDropdown_title__2j-LT"};